<template>
  <div class="data_board">
    <!-- 运营商 项目 查询 重置 -->
    <div class="operation_box">
      <el-select
        v-model="id_operator"
        placeholder="请选择运营商"
        class="select"
        @change="id_project = ''"
        v-supAdmin
      >
        <el-option
          v-for="item in operatorList"
          :key="item.id_operator"
          :label="item.name_operator"
          :value="item.id_operator"
        ></el-option>
      </el-select>
      <el-select v-model="id_project" placeholder="请选择项目" class="select">
        <el-option
          v-for="item in computedProject"
          :key="item.id"
          :label="item.name_project"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-button type="success" icon="el-icon-search" @click="search"
        >查询</el-button
      >
      <el-button type="info" icon="el-icon-refresh-left" @click="reset"
        >重置</el-button
      >
    </div>

    <!-- 图表区域 -->
    <div class="chart_log">
      <div class="chart_box">
        <!-- 设备统计 -->
        <div class="device_count">
          <div class="count">
            <div class="desc_box">
              <img src="../../../assets/board_air.png" alt="" />
              <span>离线/在线</span>
            </div>

            <div class="num_box">
              <div></div>
              <div class="center">
                <span class="num"
                  >{{ deviceCount.cnt_offline || '0' }}/{{
                    deviceCount.cnt_online || '0'
                  }}</span
                >
                <span class="unit">台</span>
              </div>
              <div class="right">
                <router-link to="/device/device_list">
                  <img src="../../../assets/board_right.png" alt=""
                /></router-link>
              </div>
            </div>
          </div>
          <div class="split"></div>
          <div class="count">
            <div class="desc_box">
              <img src="../../../assets/board_err.png" alt="" />
              <span>异常设备</span>
            </div>

            <div class="num_box">
              <div></div>
              <div class="center">
                <span class="num">{{ deviceCount.cnt_unusual || '0' }}</span>
                <span class="unit">台</span>
              </div>
              <div class="right">
                <router-link to="/data_center/err_device">
                  <img src="../../../assets/board_right.png" alt="" />
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <!-- 运行状态 echart -->
        <div class="run_echart">
          <div class="title_box">
            <div class="left">
              <div class="color"></div>
              <div class="title">空调运行数量</div>
            </div>
            <div class="right">
              <el-radio-group
                v-model="runStateNav"
                size="small"
                fill="#50e399"
                @change="getRunCount"
              >
                <el-radio-button :label="1">昨日</el-radio-button>
                <el-radio-button :label="2">今日</el-radio-button>
              </el-radio-group>
            </div>
          </div>
          <div class="echart_box">
            <div id="runChartRef" style="width: 100%;height:367px;"></div>
          </div>
        </div>
      </div>
      <div class="split"></div>
      <div class="log_box">
        <div class="title_box">
          <div class="left">
            <div class="color"></div>
            <div class="title">系统日志</div>
          </div>
          <router-link class="more" to="/system_log">查看更多</router-link>
        </div>
        <div class="log_list">
          <div class="log" v-for="item in logList" :key="item.id">
            <span class="time">{{ item.time_create.substr(5, 11) }}</span>

            <el-tooltip
              class="item"
              effect="light"
              :content="item.addr"
              placement="left"
            >
              <span class="addr" :class="'state' + item.action_type">{{
                item.addr && item.addr.length > 8
                  ? item.addr.substr(0, 7) + '...'
                  : item.addr || '(初始化设备)'
              }}</span>
            </el-tooltip>

            <span class="action"
              >{{ item.user_name }}:{{ item.action_type | actionTypeFmt }}</span
            >
          </div>
        </div>
      </div>
    </div>

    <!-- 图表区域2 底部图标 -->
    <div class="foot_chart_box">
      <div class="left_box">
        <div class="title_box">
          <div class="color"></div>
          <div class="title">空调运行状态</div>
        </div>
        <div class="total_and_echart">
          <div class="total">
            <span class="tip">在线空调</span>
            <span class="num">{{ deviceCount.cnt_online }}</span>
          </div>
          <div class="chart_box">
            <div id="run_state" style="width: 100%; height: 273px"></div>
          </div>
        </div>
      </div>
      <div class="split"></div>
      <div class="right_box">
        <div class="title_box">
          <div class="left">
            <div class="color"></div>
            <div class="title">空调运行时长</div>
          </div>
          <div class="right">
            <el-date-picker
              v-if="dateNav === 1"
              v-model="dayDate"
              type="date"
              placeholder="选择日"
              size="small"
              :clearable="false"
              style="width: 140px; margin-right:24px"
              value-format="yyyy-MM-dd"
              @change="getRunTime"
            >
            </el-date-picker>
            <el-date-picker
              v-else
              v-model="monthDate"
              type="month"
              placeholder="选择月"
              style="width: 140px; margin-right:24px"
              size="small"
              :clearable="false"
              value-format="yyyy-MM"
              @change="getRunTime"
            >
            </el-date-picker>

            <el-radio-group
              v-model="dateNav"
              size="small"
              fill="#50e399"
              text-color="#fff"
              style="margin-right:36px"
              @change="getRunTime"
            >
              <el-radio-button :label="1">日</el-radio-button>
              <el-radio-button :label="2">月</el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <div class="chart_box">
          <div id="area_echart" style="width: 100%; height: 260px"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echart from 'echarts'
import operator from '@/mixins/operator.js'
import project from '@/mixins/project.js'
import {
  GetDeviceCountApi,
  GetDeviceRunCountApi,
  GetLogListApi,
  GetDeviceRunTimeApi
} from '@/api'
import DateFmt from '@/utils/DateFmt.js'
import { actionTypeFmt } from '@/utils/filter.js'

export default {
  name: 'data_board',
  mixins: [operator, project],
  data() {
    return {
      // 权限级别
      level: '',
      // 运营商
      id_operator: '',
      // 项目
      id_project: '',
      // 运行状态 nav 1昨日  2今日
      runStateNav: 1,
      // 空调运行时长 实例
      echart1: null,
      // echart1 数据备份 页面尺寸变更时重新渲染
      echart1Data: null,
      echart2: null,
      echart2Data: null,
      echart3: null,
      echart3Data: null,
      // 延时刷新echart
      timer: null,
      // 日日期
      dayDate: '',
      // 月日期
      monthDate: '',
      // 1日  2月
      dateNav: 1,
      // 设备统计数
      deviceCount: '',
      // 日志列表
      logList: []
    }
  },
  methods: {
    // 点击查询
    search() {
      this.getDeviceCount()
      this.getRunCount()
      this.getLogList()
      this.getRunTime()
    },

    // 点击重置
    reset() {
      this.id_operator = ''
      this.id_project = ''
      this.getDeviceCount()
      this.getRunCount()
      this.getLogList()
      this.getRunTime()
    },

    // 获取设备数量统计
    async getDeviceCount() {
      const params = {}
      if (this.id_operator) {
        params.id_operator = this.id_operator
      }
      if (this.id_project) {
        params.id_project = this.id_project
      }
      const { ret, data, msg } = await GetDeviceCountApi(params)
      if (ret !== 0) {
        return this.$message.error(msg)
      }
      this.deviceCount = data
      const yData = [
        data.cnt_online - data.cnt_run,
        data.cnt_run,
        data.cnt_fault
      ]
      this.echart2Data = yData
      this.renderRunState(yData)
    },

    // 获取空调运行数量
    async getRunCount() {
      const params = {}
      if (this.runStateNav === 1) {
        const date = DateFmt.getBefore(new Date(), -1, 'yyyy-MM-dd')
        params.time_start = date + ' 00:00:00'
        params.time_end = date + ' 23:59:59'
      } else {
        const date = DateFmt.format(new Date(), 'yyyy-MM-dd')
        params.time_start = date + ' 00:00:00'
        params.time_end = date + ' 23:59:59'
      }
      if (this.id_operator) {
        params.id_operator = this.id_operator
      }
      if (this.id_project) {
        params.id_project = this.id_project
      }
      const { ret, data, msg } = await GetDeviceRunCountApi(params)
      if (ret !== 0) {
        return this.$message.error(msg)
      }
      const xData = []
      const yData = []
      data.map(i => {
        xData.push(i.time.substr(11, 5))
        yData.push(i.cnt)
      })
      this.echart1Data = [xData, yData]
      this.renderRunNumber(xData, yData)
    },

    // 获取系统日志
    async getLogList() {
      const params = {
        page_id: 0,
        page_num: 16
      }
      if (this.id_operator) {
        params.id_operator = this.id_operator
      }
      if (this.id_project) {
        params.id_project = this.id_project
      }
      const { ret, data, msg } = await GetLogListApi(params)
      if (ret !== 0) {
        return this.$message.error(msg)
      }
      this.logList = data.data
    },

    // 获取空调运行时长
    async getRunTime() {
      const params = {}
      if (this.id_operator) {
        params.id_operator = this.id_operator
      }
      if (this.id_project) {
        params.id_project = this.id_project
      }
      // 日
      if (this.dateNav === 1) {
        params.time_start = this.dayDate + ' 00:00:00'
        params.time_end = this.dayDate + ' 23:59:59'
      } else {
        // 月
        const dateArr = this.monthDate.split('-')
        const days = DateFmt.getDays(dateArr[0] / 1, dateArr[1] / 1)
        params.time_start = `${this.monthDate}-01 00:00:00`
        params.time_end = `${this.monthDate}-${days} 23:59:59`
      }
      const { ret, data, msg } = await GetDeviceRunTimeApi(params)
      if (ret !== 0) {
        return this.$message.error(msg)
      }
      if (!data.length) {
        this.$message.warning('暂无数据')
      }
      const chartData = []
      data.map(i => {
        chartData.push({
          time: parseInt(i.duration / 3600),
          name: i.name_building
        })
      })
      this.echart3Data = chartData
      this.renderRunTime(chartData)
    },

    // 渲染空调运行数量 折线图
    renderRunNumber(xData, yData) {
      this.echart1 && this.echart1.dispose()
      this.echart1 = echart.init(document.querySelector('#runChartRef'))
      const option = {
        xAxis: {
          type: 'category',
          data: xData,
          boundaryGap: false,
          // 是否显示分割线
          splitLine: {
            show: true
          },
          // 刻度名称
          axisLabel: {
            color: '#B4B9C6'
          },
          // 刻度
          axisTick: {
            show: false
          },
          // 坐标轴线
          axisLine: {
            show: false
          }
        },
        yAxis: {
          name: '台',
          type: 'value',
          minInterval: 1,
          splitLine: {
            show: true
          },
          axisLine: {
            show: false
          }
        },
        tooltip: {
          show: true,
          trigger: 'axis',
          formatter(v) {
            return `${v[0].axisValue}</br>${v[0].value}`
          }
        },
        series: [
          {
            data: yData,
            type: 'line',
            lineStyle: {
              color: '#50e399'
            },
            itemStyle: {
              color: '#50e399'
            },
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: 'rgba(80, 227, 153, .2)' // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: '#fff' // 100% 处的颜色
                  }
                ],
                global: false // 缺省为 false
              }
            }
          }
        ]
      }

      // 使用刚指定的配置项和数据显示图表。
      this.echart1.setOption(option)
    },

    // 渲染左下角柱状图
    renderRunState(yData) {
      this.echart2 && this.echart2.dispose()
      this.echart2 = echart.init(document.getElementById('run_state'))
      const seriesData = []
      const colorData = ['#0062ff', '#50e399', '#ff7e90']
      yData.map((i, index) => {
        seriesData.push({
          value: i,
          itemStyle: {
            color: colorData[index]
          }
        })
      })
      const option = {
        xAxis: {
          type: 'category',
          data: ['待机中', '运行中', '故障'],
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#B4B9C6'
            }
          }
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: false
          },
          axisLabel: {
            show: false
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: false
          }
        },
        series: [
          {
            data: seriesData,
            type: 'bar',
            barWidth: '16px',
            itemStyle: {
              normal: {
                borderRadius: [8, 8, 0, 0],
                label: {
                  show: true,
                  position: 'top',
                  textStyle: {
                    color: '#12203E',
                    fontSize: 16,
                    fontWeight: 600
                  }
                }
              }
            }
          }
        ]
      }

      this.echart2.setOption(option)
    },

    // 渲染气泡图
    renderRunTime(chartData) {
      this.echart3 && this.echart3.dispose()
      this.echart3 = echart.init(document.querySelector('#area_echart'))
      // 使用刚指定的配置项和数据显示图表。
      chartData.map((i, index) => {
        i.size = (20 - index) * 5
      })

      const color = [
        [80, 227, 147],
        [34, 222, 202],
        [140, 155, 252],
        [255, 197, 121],
        [255, 220, 105],
        [140, 146, 205],
        [255, 206, 216],
        [199, 245, 177],
        [220, 214, 255],
        [156, 226, 255]
      ]
      const data = []

      chartData.map((item, index) => {
        data.push({
          name: item.name + '\n\n' + item.time + 'h',
          value: 111,
          symbolSize: item.size,
          draggable: true,
          label: {
            normal: {
              textStyle: {
                fontSize: 16,
                color: '#fff'
              }
            }
          },
          itemStyle: {
            normal: {
              // 背景色
              color: `rgba(${color[index].join(',')}, 1)`,
              opacity: 1,
              borderWidth: 1,
              borderColor: `rgba(${color[index].join(',')}, .6)`,
              shadowBlur: 7,
              symbolOffset: 0.6,
              shadowColor: `rgba(${color[index].join(',')},.2)`
            }
          }
        })
      })

      const option = {
        backgroundColor: '#fff',
        animationDurationUpdate: function(idx) {
          return idx * 100
        },
        tooltip: {
          trigger: 'item',
          formatter: function(params, ticket, callback) {
            return params.data.tips || params.name
          }
        },
        animationEasingUpdate: 'bounceIn',
        itemStyle: {
          // color: 'red',
        },
        cursor: 'pointer',
        series: [
          {
            type: 'graph',
            layout: 'force',
            cursor: 'pointer',
            force: {
              repulsion: 100,
              edgeLength: 20
            },
            roam: true,
            label: {
              normal: {
                show: true
              }
            },
            data
          }
        ]
      }

      this.echart3.setOption(option)
    },

    // 渲染echart
    renderAllEchart() {
      // 防抖
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(() => {
        if (this.echart1Data) {
          this.renderRunNumber(...this.echart1Data)
        }
        if (this.echart2Data) {
          this.renderRunState(this.echart2Data)
        }
        if (this.echart3Data) {
          this.renderRunTime(this.echart3Data)
        }
      }, 500)
    },

    // 添加事件监听
    addListen() {
      window.addEventListener('resize', this.renderAllEchart)
    },

    // 移除事件监听
    removeListen() {
      window.removeEventListener('resize', this.renderAllEchart)
    }
  },
  created() {
    this.level = this.$store.getters.level
    if (this.level === 100) {
      this.getOperatorList()
    }
    this.getProjectList()
    // 默认填充 运行时长 日和月
    this.dayDate = DateFmt.format(new Date(), 'yyyy-MM-dd')
    this.monthDate = DateFmt.format(new Date(), 'yyyy-MM')
    // 获取系统日志
    this.getLogList()
  },
  mounted() {
    this.addListen()
    // 获取左边中间 设备运行柱状图
    this.getRunCount()
    // 获取设备统计数据(渲染左下角柱状图)
    this.getDeviceCount()
    // 获取空调运行时长统计图
    this.getRunTime()
  },
  computed: {
    // 计算项目
    computedProject() {
      if (this.level === 100) {
        if (this.id_operator) {
          return this.projectList.filter(i => {
            return i.id_operator === this.id_operator
          })
        } else {
          return this.projectList
        }
      } else {
        return this.projectList
      }
    }
  },
  filters: {
    actionTypeFmt
  },
  beforeDestroy() {
    this.removeListen()
  }
}
</script>

<style lang="scss" scoped>
.data_board {
  padding: 0 30px;
}

.operation_box {
  height: 66px;
  line-height: 66px;

  .select {
    width: 200px;
    margin-right: 10px;
  }
}

.chart_log {
  display: flex;
  height: 585px;

  .chart_box {
    flex: 1;

    .device_count {
      height: 138px;
      display: flex;

      .count {
        flex: 1;
        height: 138px;
        background-color: #fff;

        .desc_box {
          display: flex;
          align-items: center;
          height: 28px;
          margin-top: 21px;

          img {
            width: 28px;
            height: 28px;
            margin: 0 13px 0 25px;
          }

          span {
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: bold;
            color: #12203e;
          }
        }

        .num_box {
          display: flex;
          align-items: center;
          justify-content: space-around;
          margin-top: 28px;

          .center {
            display: flex;
            align-items: center;

            .num {
              font-size: 24px;
              font-family: Alibaba PuHuiTi;
              font-weight: 500;
              color: #12203e;
            }

            .unit {
              font-size: 16px;
              font-family: Alibaba;
              font-weight: normal;
              color: #738097;
              margin-left: 12px;
            }
          }

          .right {
            width: 20px;
            height: 20px;

            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }

      .split {
        flex: 0 0 30px;
      }
    }

    .run_echart {
      height: 427px;
      margin-top: 20px;
      background-color: #fff;

      .title_box {
        height: 60px;
        display: flex;
        justify-content: space-between;
        padding: 0 43px 0 0;

        .left {
          height: 60px;
          display: flex;
          align-items: center;
          .color {
            width: 4px;
            height: 18px;
            background: linear-gradient(-75deg, #50e379, #50e398);
            box-shadow: 0px 3px 4px 0px rgba(80, 227, 146, 0.35);
            margin: 0 23px;
          }

          .title {
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: bold;
            color: #12203e;
          }
        }

        .right {
          height: 60px;
          display: flex;
          align-items: flex-end;
        }
      }

      .echart_box {
        height: 367px;
      }
    }
  }

  .split {
    flex: 0 0 20px;
  }

  .log_box {
    flex: 0 0 460px;
    background-color: #ffffff;

    .title_box {
      padding-top: 21px;
      height: 45px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .left {
        display: flex;
        align-items: center;

        .color {
          width: 4px;
          height: 18px;
          background: linear-gradient(-75deg, #50e379, #50e398);
          box-shadow: 0px 3px 4px 0px rgba(80, 227, 146, 0.35);
          margin: 0 23px 0 24px;
        }

        .title {
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: bold;
          color: #12203e;
        }
      }

      .more {
        font-size: 12px;
        font-family: Alibaba PuHuiTi;
        font-weight: 400;
        color: #b4b9c6;
        margin-right: 36px;
      }
    }

    .log_list {
      height: 540px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      font-size: 12px;
      padding: 10px 0;

      .log {
        display: flex;
        font-size: 12px;
        font-family: AlibabaPuHuiTi;
        font-weight: 500;
        padding: 0 0 0 35px;

        .time {
          flex: 0 0 100px;
          color: #12203e;
        }

        .addr {
          flex: 2;
          color: #12203e;
          padding-left: 4%;

          &.state1,
          &.state2 {
            position: relative;

            &::before {
              content: '';
              position: absolute;
              left: 0;
              top: 50%;
              transform: translateY(-50%);
              width: 5px;
              height: 5px;
              background: #50e399;
              box-shadow: 0 0 2px 2px rgba(80, 227, 153, 0.3);
              border-radius: 50%;
            }
          }

          &.state3,
          &.state4 {
            position: relative;

            &::before {
              content: '';
              position: absolute;
              left: 0;
              top: 50%;
              transform: translateY(-50%);
              width: 5px;
              height: 5px;
              background: #ffc579;
              box-shadow: 0 0 2px 2px rgba(255, 197, 121, 0.3);
              border-radius: 50%;
            }
          }

          &.state5 {
            position: relative;

            &::before {
              content: '';
              position: absolute;
              left: 0;
              top: 50%;
              transform: translateY(-50%);
              width: 5px;
              height: 5px;
              background: #ff7e90;
              box-shadow: 0 0 2px 2px rgba(255, 126, 144, 0.3);
              border-radius: 50%;
            }
          }
        }

        .action {
          flex: 3;
          color: #12203e;
        }
      }
    }
  }
}

.foot_chart_box {
  height: 337px;
  margin: 20px 0;
  display: flex;

  .left_box {
    flex: 1;
    background-color: #fff;

    .title_box {
      height: 64px;
      display: flex;
      align-items: center;

      .color {
        width: 4px;
        height: 18px;
        background: linear-gradient(-75deg, #50e379, #50e398);
        box-shadow: 0px 3px 4px 0px rgba(80, 227, 146, 0.35);
        margin: 0 26px 0 24px;
      }

      .title {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #12203e;
      }
    }

    .total_and_echart {
      height: 273px;
      display: flex;

      .total {
        height: 273px;
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .tip {
          font-size: 14px;
          font-family: Alibaba PuHuiTi;
          font-weight: 500;
          color: #12203e;
        }

        .num {
          font-size: 36px;
          font-family: Gilroy;
          font-weight: bold;
          color: #12203e;
          margin-top: 15px;
        }
      }

      .chart_box {
        flex: 1;
      }
    }
  }

  .split {
    flex: 0 0 20px;
  }

  .right_box {
    flex: 1;
    height: 337px;
    background-color: #fff;

    .title_box {
      height: 60px;
      display: flex;
      justify-content: space-between;

      .left {
        display: flex;
        align-items: center;

        .color {
          width: 4px;
          height: 18px;
          background: linear-gradient(-75deg, #50e379, #50e398);
          box-shadow: 0px 3px 4px 0px rgba(80, 227, 146, 0.35);
          margin: 0 25px 0 24px;
        }

        .title {
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: bold;
          color: #12203e;
        }
      }

      .right {
        display: flex;
        align-items: flex-end;
      }
    }

    .chart_box {
      height: 260px;
      width: 100%;
      margin-top: 17px;
    }
  }
}
</style>
